export const receiptStatusText: Record<string, string> = {
  DRAFT: '草稿',
  READY: '已启用',
  RECOGNIZED: '已生成应收',
  CANCELLED: '已取消',
  PENDING: '待财务确认',
  CONFIRMED: '已确认',
  REJECTED: '已驳回',
  WITHDRAWN: '已撤回',
  PARTIAL: '部分回款',
  COMPLETED: '已结清',
  UNKNOWN: '待同步',
  NOT_SYNCED: '未同步',
  SYNCED: '已同步',
  FAILED: '同步失败',
  RECEIPT: '收款',
  REVERSAL: '冲正',
  BANK_TRANSFER: '银行转账',
  CASH: '现金',
  CHECK: '支票',
  OTHER: '其他',
};

export const receiptProgressText: Record<string, string> = {
  PENDING: '未回款',
  PARTIAL: '部分回款',
  COMPLETED: '已结清',
  UNKNOWN: '待同步',
};
export const receiptSyncText: Record<string, string> = {
  NOT_SYNCED: '未同步',
  PENDING: '同步中',
  SYNCED: '已同步',
  FAILED: '同步失败',
};
export function receiptFieldText(field: string, value: string) {
  return (
    (field === 'progress'
      ? receiptProgressText
      : ['syncStatus', 'financeSyncStatus'].includes(field)
        ? receiptSyncText
        : receiptStatusText)[value] ||
    value ||
    '待同步'
  );
}
